import { FelaCSS, FelaCSSWithCustomSelectors } from '../../../../components/fela/flowtypes';
import colorParse from '../../../../fela-utils/color-parse';
import { colors } from '../../../../themes/variables';
import { SharedTypes as PropTypes } from './radio-toggle';

interface StyleTypes {
  wrapper: FelaCSS;
  iconWrap: FelaCSSWithCustomSelectors;
  label: FelaCSS;
}

const styles = ({
  color,
  checked,
  iconColor,
  disabled,
  noIconColor,
  noBorder,
  withBackground,
}: PropTypes): StyleTypes => {
  const themeColor = color ? colorParse(color) : colors.space;
  const getIconColor = disabled
    ? colors.space15
    : iconColor
      ? colorParse(iconColor)
      : colors.space || themeColor || colors.space;

  const wrapperDisabled: FelaCSS = disabled
    ? {
        pointerEvents: 'none',
        cursor: 'default',
        color: colors.space15,
        borderColor: colors.space15,
      }
    : {
        color: checked ? colors.white : colors.space,
        borderColor: checked ? themeColor : colors.space40,
        cursor: 'pointer',

        ':hover': {
          backgroundColor: undefined,

          desktopDesign: {
            backgroundColor:
              withBackground && checked ? colors.space15 : checked ? undefined : colors.space15,
          },
        },
      };

  return {
    wrapper: {
      ...wrapperDisabled,
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      paddingLeft: '8px',
      paddingRight: '8px',
      height: '34px',
      fontDefaultSemiBold: 14,
      lineHeight: '14px',
      borderWidth: noBorder ? '0px' : '1px',
      borderStyle: 'solid',
      borderRadius: '100px',
      boxSizing: 'border-box',
      backgroundColor: checked ? themeColor : 'transparent',
      ...(withBackground && {
        backgroundColor: checked ? colors.space : colors.indigoCrush04,
      }),
    },

    iconWrap: {
      justifyContent: 'center',
      marginRight: '4px',
      ...(!noIconColor && {
        '> div': {
          '> svg': {
            '> path': {
              fill: checked ? colors.white : getIconColor,
            },
          },
        },
      }),
    },
    label: {
      fontDefault: 14,
    },
  };
};

export default styles;
